import Styled from 'styled-components'

export const Container = Styled.nav`
margin-bottom: 40px;
`

export const ContainerHotel = Styled.div`
height: 100%;
border-bottom: 2px solid rgba(117, 117, 117, 0.32);
padding-bottom: 25px;
margin-bottom: 25px;

.hotel {
    padding: 3px;
    background-color: #696969;
    text-align: center;
    color: white;
    margin-bottom: 0;
    font-size: 13px;
}

.image {
    width: 80%;
}

`

export const HotelImages = Styled.img`
width: 100%;
height: 100%;
object-fit: cover;  
`


export const InformationHotel = Styled.div`

width: 100%;

p{
    margin-bottom: 0;
}

`

export const ContainerPrice = Styled.div`
padding-left: 38px;

.daily {
    color: #263238;
    font-weight: 400;
    font-size: 13px;
}

.price{
    color: #263238;
    font-weight: 700;
    font-size: 26px;

    span{
        font-size: 19px;
    }
}

.taxa{
    color: rgba(38, 50, 56, 0.5);
    font-weight: 400;
    font-size: 12px;
    margin-top: -5px;
    margin-bottom: 0px
}
`

export const ContentHotel = Styled.div`
margin-left: 15px;

.title-hotel {
    margin: 5px 0;
    color: ${props => props.theme.primary};
    font-weight: 700;
    font-size: 17px;
    text-transform: lowercase;
    line-height: 16px;
}

.title-hotel{ 
    text-transform: capitalize;
}

.stars{
    position: relative;
    z-index: -1;

    .css-iljtu2-MuiRating-root{
       color: ${props => props.theme.primary};
    }
}

.info {
     width: auto;
     padding: 0;
     color: rgba(5, 9, 34, 0.6);
     font-weight: 400;
     font-size: 13px;
     display: inline-flex;
     gap: 5px;
     margin: 0.5rem 0 0.8rem;
}

.mapa{
    color: ${props => props.theme.primary};
    font-weight: 400;
    font-size: 12px;

    svg {
        width: 20px;
        height: 20px;
        margin-right: 2px;
    }
}
`

export const Line = Styled.div`
border-bottom: 2px solid #C6C6C5; 
margin-top: 30px;
`
